/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* --- Sax & Ro: Length availability fix (added Aug 2026) ---------------------
   Swatch King only computes the Length "sold out" strikethrough for the color
   selected at page load, so an out-of-stock default color (e.g. Brunette #1 22")
   left 22" crossed out for EVERY color. This recomputes Length availability
   whenever the selected color/variant changes. Safe to delete once the
   RESKIN 2026 theme (which handles this correctly) goes live. */
(function () {
  var cache = null, t;
  function fix() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    function apply(p) {
      var lenIdx = p.options.map(function (o) { return o.name.toLowerCase(); }).indexOf('length');
      if (lenIdx < 0) return;
      var vid = new URLSearchParams(location.search).get('variant');
      var cur = null, i;
      for (i = 0; i < p.variants.length; i++) { if (String(p.variants[i].id) === vid) { cur = p.variants[i]; break; } }
      if (!cur) { for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { cur = p.variants[i]; break; } } }
      if (!cur) cur = p.variants[0];
      var vals = p.options[lenIdx].values;
      document.querySelectorAll('ul.swatch-view').forEach(function (ul) {
        var items = Array.prototype.slice.call(ul.querySelectorAll('li.swatch-view-item'));
        var texts = items.map(function (x) { return x.textContent.trim(); });
        var isLengthGroup = vals.every(function (v) { return texts.indexOf(v) >= 0; });
        if (!isLengthGroup) return;
        items.forEach(function (item) {
          var val = item.textContent.trim();
          var match = null;
          for (var j = 0; j < p.variants.length; j++) {
            var v = p.variants[j];
            if (v.options[lenIdx] !== val) continue;
            var ok = true;
            for (var k = 0; k < v.options.length; k++) { if (k !== lenIdx && v.options[k] !== cur.options[k]) { ok = false; break; } }
            if (ok) { match = v; break; }
          }
          item.classList.toggle('swatch-item-unavailable', !(match && match.available));
        });
      });
    }
    if (cache && cache.handle === m[1]) { apply(cache.data); return; }
    fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) { cache = { handle: m[1], data: p }; apply(p); }).catch(function () {});
  }
  function later() { clearTimeout(t); t = setTimeout(fix, 400); }
  document.addEventListener('click', later, true);
  window.addEventListener('popstate', later);
  var ps = history.pushState; history.pushState = function () { ps.apply(this, arguments); later(); };
  var rs = history.replaceState; history.replaceState = function () { rs.apply(this, arguments); later(); };
  if (document.readyState !== 'loading') { setTimeout(fix, 600); } else { document.addEventListener('DOMContentLoaded', function () { setTimeout(fix, 600); }); }
})();
